"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var inertia_react_1 = require("@inertiajs/inertia-react");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var useRoute_1 = __importDefault(require("@/Hooks/useRoute"));
var ActionMessage_1 = __importDefault(require("@/Jetstream/ActionMessage"));
var ActionSection_1 = __importDefault(require("@/Jetstream/ActionSection"));
var Button_1 = __importDefault(require("@/Jetstream/Button"));
var DialogModal_1 = __importDefault(require("@/Jetstream/DialogModal"));
var Input_1 = __importDefault(require("@/Jetstream/Input"));
var InputError_1 = __importDefault(require("@/Jetstream/InputError"));
var SecondaryButton_1 = __importDefault(require("@/Jetstream/SecondaryButton"));
function LogoutOtherBrowserSessions(_a) {
    var sessions = _a.sessions;
    var _b = (0, react_1.useState)(false), confirmingLogout = _b[0], setConfirmingLogout = _b[1];
    var route = (0, useRoute_1.default)();
    var passwordRef = (0, react_1.useRef)(null);
    var form = (0, inertia_react_1.useForm)({
        password: '',
    });
    function confirmLogout() {
        setConfirmingLogout(true);
        setTimeout(function () { var _a; return (_a = passwordRef.current) === null || _a === void 0 ? void 0 : _a.focus(); }, 250);
    }
    function logoutOtherBrowserSessions() {
        form.delete(route('other-browser-sessions.destroy'), {
            preserveScroll: true,
            onSuccess: function () { return closeModal(); },
            onError: function () { var _a; return (_a = passwordRef.current) === null || _a === void 0 ? void 0 : _a.focus(); },
            onFinish: function () { return form.reset(); },
        });
    }
    function closeModal() {
        setConfirmingLogout(false);
        form.reset();
    }
    return (react_1.default.createElement(ActionSection_1.default, { title: 'Browser Sessions', description: 'Manage and log out your active sessions on other browsers and devices.' },
        react_1.default.createElement("div", { className: "max-w-xl text-sm text-gray-600" }, "If necessary, you may log out of all of your other browser sessions across all of your devices. Some of your recent sessions are listed below; however, this list may not be exhaustive. If you feel your account has been compromised, you should also update your password."),
        sessions.length > 0 ? (react_1.default.createElement("div", { className: "mt-5 space-y-6" }, sessions.map(function (session, i) { return (react_1.default.createElement("div", { className: "flex items-center", key: i },
            react_1.default.createElement("div", null, session.agent.is_desktop ? (react_1.default.createElement("svg", { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", viewBox: "0 0 24 24", stroke: "currentColor", className: "w-8 h-8 text-gray-500" },
                react_1.default.createElement("path", { d: "M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" }))) : (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", strokeWidth: "2", stroke: "currentColor", fill: "none", strokeLinecap: "round", strokeLinejoin: "round", className: "w-8 h-8 text-gray-500" },
                react_1.default.createElement("path", { d: "M0 0h24v24H0z", stroke: "none" }),
                react_1.default.createElement("rect", { x: "7", y: "4", width: "10", height: "16", rx: "1" }),
                react_1.default.createElement("path", { d: "M11 5h2M12 17v.01" })))),
            react_1.default.createElement("div", { className: "ml-3" },
                react_1.default.createElement("div", { className: "text-sm text-gray-600" },
                    session.agent.platform,
                    " - ",
                    session.agent.browser),
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: "text-xs text-gray-500" },
                        session.ip_address,
                        ",",
                        session.is_current_device ? (react_1.default.createElement("span", { className: "text-green-500 font-semibold" }, "This device")) : (react_1.default.createElement("span", null,
                            "Last active ",
                            session.last_active))))))); }))) : null,
        react_1.default.createElement("div", { className: "flex items-center mt-5" },
            react_1.default.createElement(Button_1.default, { onClick: confirmLogout }, "Log Out Other Browser Sessions"),
            react_1.default.createElement(ActionMessage_1.default, { on: form.recentlySuccessful, className: "ml-3" }, "Done.")),
        react_1.default.createElement(DialogModal_1.default, { isOpen: confirmingLogout, onClose: closeModal },
            react_1.default.createElement(DialogModal_1.default.Content, { title: 'Log Out Other Browser Sessions' },
                "Please enter your password to confirm you would like to log out of your other browser sessions across all of your devices.",
                react_1.default.createElement("div", { className: "mt-4" },
                    react_1.default.createElement(Input_1.default, { type: "password", className: "mt-1 block w-3/4", placeholder: "Password", ref: passwordRef, value: form.data.password, onChange: function (e) { return form.setData('password', e.currentTarget.value); } }),
                    react_1.default.createElement(InputError_1.default, { message: form.errors.password, className: "mt-2" }))),
            react_1.default.createElement(DialogModal_1.default.Footer, null,
                react_1.default.createElement(SecondaryButton_1.default, { onClick: closeModal }, "Cancel"),
                react_1.default.createElement(Button_1.default, { onClick: logoutOtherBrowserSessions, className: (0, classnames_1.default)('ml-2', { 'opacity-25': form.processing }), disabled: form.processing }, "Log Out Other Browser Sessions")))));
}
exports.default = LogoutOtherBrowserSessions;
